import React from "react";
import { Badge } from "shards-react";

const CumulativeColumn =  () => {
    return [
        {
            Header: '',
            accessor: 'period',
        }, {
            Header: <Badge pill style={{backgroundColor: 'gray'}}> RDV demandés par le patient </Badge>,
            accessor: 'patient',
            minWidth: 210,
        },{
            Header: <Badge pill style={{backgroundColor: 'gray'}}> Empreintes </Badge>,
            accessor: 'fingerprint',
            minWidth: 110,
        },{
            Header: <Badge pill style={{ backgroundColor: '#0089BA' }}> Ratio <br/> RDV demandés par le Patient / Empreintes </Badge>,
            Cell: row => {
                const ratio = ((100 * row.original.fingerprint) / row.original.patient);
                const backgroundColor = ratio > 60 ? '#008F7A' : '#C34A36';
                return <Badge pill style={{ backgroundColor }}> { isNaN(ratio) ? "-" : ratio.toFixed(2) }% </Badge>;
            },
            minWidth: 280,
        },{
            Header: <Badge pill style={{backgroundColor: 'gray'}}> RDV demandés par le praticien </Badge>,
            accessor: 'practitioner',
            minWidth: 210,
        },{
            Header: <Badge pill style={{backgroundColor: 'gray'}}> Total RDV cloturés </Badge>,
            accessor: 'closed',
            minWidth: 180,
        }, {
            Header: <Badge pill style={{ backgroundColor: '#0089BA' }}> Ratio <br/> Total TC / Total RDV cloturés </Badge>,
            Cell: row => {
                const ratio = ((100 * row.original.closed) / (row.original.practitioner + row.original.patient));
                const backgroundColor = ratio > 60 ? '#008F7A' : '#C34A36';
                return <Badge pill style={{ backgroundColor }}> { isNaN(ratio) ? "-" : ratio.toFixed(2) }% </Badge>;
            },
            minWidth: 220,
        },{
            Header: <Badge pill style={{backgroundColor: 'gray'}}> Payés </Badge>,
            accessor: 'paid'
        },{
            Header: <Badge pill style={{ backgroundColor: '#0089BA' }}> Ratio <br/>  Total RDV demandés / Payés </Badge>,
            Cell: row => {
                const ratio = ((100 * row.original.paid) / (row.original.practitioner + row.original.patient));
                const backgroundColor = ratio > 60 ? '#008F7A' : '#C34A36';
                return <Badge pill style={{ backgroundColor }}> { isNaN(ratio) ? "-" : ratio.toFixed(2) }% </Badge>;
            },
            minWidth: 250
        },
    ]
}

export default CumulativeColumn;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/Cumulative/CumulativeColumn.js